import gql from "graphql-tag";

/**
 * Generates membership badge pdf by the order token.
 * NOTE: pending backend support — the badges GraphQL must accept a `token` arg on
 * `generateMembershipBadgePdf`. Re-run codegen and switch to the generated
 * Query/Variables types once the schema exposes it.
 */
export const GET_GenerateBadgePdfByToken = gql`
  query GET_GenerateBadgePdfByToken($token: String!, $locarno: Boolean!) {
    generateMembershipBadgePdf(token: $token, locarno: $locarno) {
      pdfBase64
    }
  }
`;

/**
 * Generates giftcard pdf by the order token.
 * NOTE: pending backend support — the badges GraphQL must accept a `token` arg on
 * `generateGiftcardPdf`.
 */
export const GET_GenerateGiftcardPdfByToken = gql`
  query GET_GenerateGiftcardPdfByToken($token: String!) {
    generateGiftcardPdf(token: $token) {
      pdfBase64
    }
  }
`;

export const Mutation_SignReceipt = gql`
  mutation SignFiskalyReceipt(
    $groupId: String!
    $deviceUid: String!
    $receiptUuid: String!
    $receiptDate: DateTime!
    $currency: String!
    $fullAmountInclVat: String!
    $paymentTypes: String!
    $vatAmounts: String!
    $lines: String!
  ) {
    signFiskalyReceipt(
      groupId: $groupId
      deviceUid: $deviceUid
      receiptUuid: $receiptUuid
      receiptDate: $receiptDate
      currency: $currency
      fullAmountInclVat: $fullAmountInclVat
      paymentTypes: $paymentTypes
      vatAmounts: $vatAmounts
      lines: $lines
    ) {
      qrCodeData
      signed
      timeSignature
      receiptNumber
    }
  }
`;

export const Mutation_StartOrder = gql`
  mutation StartOrder($deviceUid: String!, $orderSession: JSONObject!) {
    startOrder(deviceUid: $deviceUid, orderSession: $orderSession) {
      orderId
    }
  }
`;

export const Mutation_CompleteOrder = gql`
  mutation CompleteOrder(
    $deviceUid: String!
    $orderType: OrderType!
    $orderSession: JSONObject!
  ) {
    completeOrder(
      deviceUid: $deviceUid
      orderType: $orderType
      orderSession: $orderSession
    ) {
      govId
      url
      signature
    }
  }
`;

export const GET_OrderSessionById = gql`
  query GetOrderSessions($orderSessionId: String!) {
    getOrderSessions(orderSessionId: $orderSessionId) {
      total
      page
      pageSize
      totalPages
      items {
        id
        reference
        orderId
        state
        completionDate
        visitDate
        voucher
        discount
        sales
        vatExcluded
        vatIncluded
        fees
        payment
        balance
        groupId
        channel
        sessionStart
        sessionEnd
        syncedAt
        expireAt
        counterId
        seqNumber
        currency
        discounts
        toPay
        discountConfigs
        createdAt
        updatedAt
        orderLines {
          id
          lineId
          orderSessionId
          categoryId
          priceId
          timeSlotId
          priceName
          retailOptionId
          retailName
          categoryName
          quantity
          unitPrice
          overridePrice
          totalPrice
          totalPriceWithDiscount
          vatId
          addonType
          vatCode
          vatValue
          vatRate
          vatType
          mainLineId
          lineType
          createdAt
          updatedAt
          mainLineOrderSessionId
        }
        payments {
          id
          orderSessionId
          paymentMethod
          value
          metadata
        }
        vouchers {
          id
          orderSessionId
          code
          voucherId
          value
          mainVoucherId
          mainVoucherOrderSessionId
        }
      }
    }
  }
`;

export const Mutation_SignAustriaReceipt = gql`
  mutation signAustriaReceipt($deviceUid: String!, $orderSession: JSONObject!) {
    signAustriaReceipt(deviceUid: $deviceUid, orderSession: $orderSession) {
      qrCodeData
      cashRegisterSerialNumber
      signed
      timeSignature
      receiptNumber
    }
  }
`;
